module.exports = __webpack_public_path__ + "media/icons/icon-bar-3-640880fc.png";